export default __webpack_public_path__ + "static/media/iconCopy.0daa615e.svg";